export default "__VITE_ASSET__qINRiyOF__"